// extracted by mini-css-extract-plugin
export default {"productGallery":"ZG-z","inQuickShop":"_G-z"};